import * as React from 'react';
import { Scroller, Slider, Image, Overlay, Buttons, PaginationFraction } from '@cian/slider';
import * as styles from './Carousel.css';
import { Responsive } from '@cian/ui-kit';
import { PaginationDots } from '../PaginationDots';

interface ICarouselProps {
  images: string[];
}

export const Carousel: React.FC<ICarouselProps> = ({ images }) => {
  return (
    <Slider loop>
      <Scroller>
        {images.map((image, index) => (
          <div key={`slide_${index}`} className={styles['slide']}>
            <Image src={image} />
          </div>
        ))}
      </Scroller>
      <Overlay hideable={false}>
        <Responsive desktop>
          <Buttons />
          <PaginationFraction />
        </Responsive>
        <Responsive tablet phone>
          <PaginationDots />
        </Responsive>
      </Overlay>
    </Slider>
  );
};
